import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { OpenTokService } from '../services/open-tok.service';
import { CommonService } from '../../../services/common/common.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
// import * as OT from '@opentok/client';

@Component({
  selector: 'chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss'],
  providers: [OpenTokService]
})
export class ChatBoxComponent implements OnInit {
  @Input('userId') userId: string;
  @Input('userName') userName: string;
  @Input('session') session: OT.Session;
  @ViewChild('chatWindow') chatWindow: ElementRef;
  @ViewChild('supportChat') supportChat: ElementRef;
  currentUser: string;
  chatHistoryData: any = [];

  constructor(
    private opentokService: OpenTokService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.currentUser = params['userId'];
    })
    this.opentokService.getAction().subscribe(data => {
      if (["receiveChatData"].includes(data.action)) {
        let chatEvent = data.data;
        let chatData = JSON.parse(chatEvent.data);
        let chatArray = { time: "", data: "", userId: "", connectionId: "", source: "", userName: "" };
        chatArray.time = this.commonService.getUTCDate(chatEvent.from.creationTime);
        chatArray.data = chatData.data;
        chatArray.userId = chatData.userId;
        chatArray.connectionId = chatEvent.from.connectionId;
        chatArray.userName = chatData.userName;
        chatArray.source = (this.currentUser === chatData.userId ? "mine" : "others");
        this.chatHistoryData.push(chatArray);
        this.scrollToBottom();
      }
    });
  }

  ngOnInit() {
    // this.opentokService.initSession().then((session: OT.Session) => {
    // this.session = session;
    // console.log(this.session);
    // this.session.on('streamCreated', (event) => {
    //   this.streams.push(event.stream);
    // });
    // this.session.on('streamDestroyed', (event) => {
    //   const idx = this.streams.indexOf(event.stream);
    //   if (idx > -1) {
    //     this.streams.splice(idx, 1);
    //   }
    // });
    // let os = this.opentokService;
    // this.session.on("signal", function signalCallback(event) {
    //   // console.log('receiving - ' + event.data);
    //   os.sendAction("receiveChatData", event);
    // });
    // })
    // .then(() => this.opentokService.connect())
    // .catch((err) => {
    //   console.error(err);
    //   alert('Unable to connect.');
    // });
    let os = this.opentokService;
    this.session.on("signal", function signalCallback(event) {
      os.sendAction("receiveChatData", event);
    });
    this.chatWindow.nativeElement.click();
  }

  sendMsg(chatBox) {
    // console.log(chatBox);
    if (chatBox.value == "") {
      return false;
    }
    let chatData = { userId: this.userId, userName: this.userName, data: chatBox.value };
    // console.log('sending - ' + JSON.stringify(chatData));
    // console.log(chatData);
    this.session.signal({
      type: 'msg',
      data: JSON.stringify(chatData)
    }, function signalCallback(error) {
      if (error) {
        console.error('Error sending signal:', error.name, error.message);
      } else {
        chatBox.value = '';
        chatBox.autofocus = true;
      }
    })
  }

  scrollToBottom(): void {
    this.chatWindow.nativeElement.click();
    this.supportChat.nativeElement.focus();
    try {
      this.chatWindow.nativeElement.scrollTop = this.chatWindow.nativeElement.scrollHeight;
      // console.log(this.chatWindow);
    } catch (err) { }
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/chat-box/chat-box.component.ts